<div class="route-container">
  <app-modal-frame
    [headerText]="CONSTANTS.ADD_ROUTE"
    [rightButton]="{
      text: CONSTANTS.ADD,
      disable: !addRouteForm.dirty || !addRouteForm.valid,
      type: BUTTON_TYPES.TEXT_BUTTON,
    }"
    (emitRightClick)="onAccept()"
    (emitExit)="onClose()"
  >
    <form [formGroup]="addRouteForm">
      <ion-row class="wrapper">
        <ion-col size="10">
          <app-form-text-field
            [labelText]="CONSTANTS.ROUTE"
            [regexType]="REGEX"
            [minLength]="3"
            [maxLength]="3"
            [form]="addRouteForm"
            [control]="'route'"
            [autoCapitalizeCharacters]="true"
            (paste)="commonUtils.sanitizePaste($event)"
          ></app-form-text-field>
        </ion-col>
      </ion-row>
    </form>
  </app-modal-frame>
</div>
